import { SET_PRODUCT } from "../types"

export const setProduct = id => ({
  type: SET_PRODUCT,
  payload: id
})

